import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'sp-base-logo',
    templateUrl: './sp-base-logo.component.html',
    styleUrls: ['./sp-base-logo.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpBaseLogoComponent {
    @Input() public logoWidth: number = 32;
    @Input() public logoHeight: number = 32;
    @Input() public logoLinkUrl: string;
    @Input() public targetBlank: boolean;
}
